// src/entities/authorComposer/components/common/AuthorFieldAdornment.tsx
import React from "react";
import { useFormRecord } from "../../../../common/controls/forms/FormRecordContext";
import { DniFieldTick } from "./DniFieldTick";
import { esCampoVerificable, marcaVisible, useEstadoAutor } from "./authorStatus";

/** Las mismas props que el asiento genérico de la parte A (FieldAdornmentProps). */
export interface AuthorFieldAdornmentProps {
  entity: string;
  field: string;
  recordId?: string;
  mode: "create" | "update" | "view";
  /**
   * El valor del campo: el que se está editando en el alta y la edición, el
   * guardado en la vista. Llega en los tres modos; en una referencia (la
   * nacionalidad) es `{ id, displayId }` o `null`.
   */
  value?: unknown;
}

/**
 * Al lado de cada campo del autor: el tic de "Dato validado con DNI" cuando corresponde.
 *
 * El número se lee con el tipo de documento que el formulario tiene en ese momento. Las props del
 * asiento traen solo el valor del campo: el tipo lo da FormRecordContext, que proveen los
 * formularios de alta y edición del autor (AuthorComposer tiene campos propios). Sin él, rige el
 * tipo guardado.
 */
export const AuthorFieldAdornment: React.FC<AuthorFieldAdornmentProps> = ({ field, recordId, mode, value }) => {
  const aplica = esCampoVerificable(field) && mode !== "create";
  const estado = useEstadoAutor(aplica ? recordId : undefined);
  const { values } = useFormRecord();
  if (!esCampoVerificable(field)) return null;
  const tipoVivo = values && "taxIdType" in values ? values.taxIdType : undefined;
  return <DniFieldTick visible={marcaVisible(estado, field, mode, value, tipoVivo)} />;
};
